import React from 'react';

export default function StatusBadge({ state }) {
  return <span className={`status-badge-chip status-badge-chip--${state.tone}`}>{state.label}</span>;
}